module.exports = __webpack_public_path__ + "img/neocity-logo.1843cc35.png";